module.exports = __webpack_public_path__ + "static/img/header.af9f918.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header.jpg
// module id = Y5I1
// module chunks = 0